import axios from "axios";
import Navbar from "../components/Navbar";
import '../styles/Form.css'
import { Cookies } from "react-cookie";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import passwordImg from '../images/password.svg'

export default function ChangePassword() {
    const cookies = new Cookies()
    const navigate = useNavigate()
    const [statusMessage, setStatusMessage] = useState('')

    useEffect(() => {
        if (!cookies.get('user')?.token) {
            navigate(`/`)
        }
    }, [])

    const onClickChangePassword = (e: any) => {
        e.preventDefault()
        const currentPassword = e.target[0].value
        const newPassword = e.target[1].value
        const confirmPassword = e.target[2].value
        setStatusMessage('Loading...')
        setTimeout(() => {
            if (newPassword !== confirmPassword) {
                setStatusMessage('New password not match')
            } else {
                axios.put('/Tokens', {
                    staffId: cookies.get('user')?.staffId,
                    oldPassword: currentPassword,
                    newPassword: newPassword
                },
                    {
                        headers: {
                            'Authorization': `Bearer ${cookies.get('user')?.token}`
                        },
                        withCredentials: true
                    }).then((res) => {
                        if (res.status === 200) {
                            setStatusMessage('Password changed successfully')
                            cookies.remove('user', { path: '/', secure: true, sameSite: 'strict' })
                            setTimeout(() => {
                                setStatusMessage('Redirect to login page...')
                                setTimeout(() => {
                                    navigate(`/`)
                                }, 2000)
                            }, 1000)
                        }
                    }).catch((err) => {
                        if (err.response.status === 401) {
                            setStatusMessage('Current password is incorrect')
                        } else {
                            setStatusMessage('Something went wrong')
                        }
                    }
                    )
            }
        }, 1000)
    }
    return (
        <div className="Form page">
            <Navbar />
            <div className="form-container">
                <form className="form" onSubmit={onClickChangePassword}>
                    <div className="form-main-title">
                        <img src={passwordImg} alt="Password Image" />
                        <h1>Change Password</h1>
                    </div>
                    <div className="form-textfield">
                        <input type="password" placeholder="Current Password" autoComplete="current-password" required/>
                    </div>
                    <div className="form-textfield">
                        <input type="password" placeholder="New Password" autoComplete="off" required/>
                    </div>
                    <div className="form-textfield">
                        <input type="password" placeholder="Confirm New Password" autoComplete="off" required/>
                    </div>
                    <div className="form-actions">
                        <button>Change Password</button>
                    </div>
                    <div className="form-status-message">
                        <p>{statusMessage}</p>
                    </div>
                </form>
            </div>
        </div>
    )
}